import { useState } from "react";
import type { Faq } from "@/mocks/faqs";

interface FaqAccordionProps {
  items: Faq[];
  defaultOpenId?: string;
}

export default function FaqAccordion({ items, defaultOpenId }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  return (
    <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpenId(open ? null : item.id)}
                className="w-full flex items-start justify-between gap-4 text-left px-5 md:px-6 py-5 cursor-pointer hover:bg-background-100/70 transition-colors"
              >
                <span className="flex items-start gap-3">
                  <span className="font-label text-sm text-accent-700 pt-0.5">
                    Q
                  </span>
                  <span className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                    {item.question}
                  </span>
                </span>
                <i
                  className={`mt-1 shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                    open ? "ri-subtract-line rotate-180" : "ri-add-line"
                  }`}
                ></i>
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-out ${
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 md:px-6 pb-5 pl-[3.1rem] text-sm md:text-[15px] leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}